import { Component, DestroyRef, effect, inject, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import type { ProductListItemDto } from '@api/models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductService } from '../../../../services/product.service';
import { ProductsPreviewComponent } from '../../../products-preview/products-preview.component';

@Component({
  selector: 'cross-sell-products',
  templateUrl: './cross-sell-products.component.html',
  styleUrls: ['./cross-sell-products.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ProductsPreviewComponent, TranslatePipe]
})
export class CrossSellProductsComponent {
  private readonly productService = inject(ProductService);
  private readonly destroyRef = inject(DestroyRef);

  readonly products = signal<ProductListItemDto[]>([]);
  protected readonly sourceForAnalytics = 'cross_sell_products';

  readonly productIds = input<number[]>(undefined);
  readonly showCart = output<number>();

  constructor() {
    effect(() => {
      this.productIds();
      this.setProducts();
    });
  }

  private setProducts() {
    this.productService.fetchProductsByIds(this.productIds())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        this.products.set(response.data);
      });
  }
}
